<template>
  <div class="grid-container grid-rows-[min-content_auto] md:mt-6 md:mb-12">
    <aside class="col-span-full md:col-start-2 md:col-end-6 xl:col-span-4">
      <div class="md:p-4 md:elevation md:rounded-lg md:border md:border-outline/16">
        <!-- ProfileDetailsSection -->
        <div class="relative md:p-1">
          <ProfileBanner class="h-24 md:hidden" :src="company.banner_image" />
          <ProfilePicture
            with-border
            :src="company.profile_image"
            :size="$window.width <= 905 ? 'medium' : 'large'"
            class="absolute right-1/2 top-1/2 translate-x-1/2 hover:shadow-none md:static md:flex md:justify-center md:transform-none"
          />
        </div>
        <div class="mt-10 md:m-0">
          <div class="md:flex md:flex-col md:gap-2 md:p-2">
            <!-- Verified Badge -->
            <div class="flex gap-2 justify-center items-center">
              <Icon name="outline-verified" class="fill-brand-bright-green" />
              <span class="text-chips text-tertiary">Empresa destacada</span>
            </div>
            <h1 class="headline-sm text-center md:headline-md">{{ company.name }}</h1>
            <h2 v-if="company.headline" class="title-md text-center md:title-lg md:font-normal">
              {{ company.headline }}
            </h2>
          </div>
          <div class="flex gap-4 p-2 justify-center fill-primary md:justify-evenly md:p-2">
            <!-- Social icons -->
            <a
              v-for="(item, key) in companySocialMedia"
              :key="key"
              :href="'//' + item.found_value"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ButtonIcon :icon="item.icon" class="btn-text" />
            </a>
          </div>
          <div
            class="flex gap-[2px] overflow-x-scroll p-1 sm:justify-center md:flex-col md:overflow-auto md:p-0"
          >
            <ListItemWithDivider :with-divider="$window.width >= 905">
              <Button
                class="btn-text fill-primary min-w-fit md:w-full"
                icon="account-circle-filled"
                @click="currentTab = 'main'"
                >Perfil</Button
              >
            </ListItemWithDivider>
            <ListItemWithDivider :with-divider="$window.width >= 905">
              <Button
                class="btn-text fill-primary min-w-fit md:w-full"
                icon="round-cases"
                @click="currentTab = 'jobs'"
                >Ofertas de trabajo</Button
              >
            </ListItemWithDivider>
            <ListItemWithDivider :with-divider="$window.width >= 905">
              <!-- TODO: Implementacion del metodo shareProfile -->
              <Button
                class="btn-text fill-primary min-w-fit md:w-full"
                icon="share"
                @click="shareProfile()"
                >Compartir perfil</Button
              >
            </ListItemWithDivider>
          </div>
          <Divider class="mx-0 md:hidden" />
        </div>
      </div>
    </aside>
    <!-- Main Container -->
    <main class="md:col-start-6 md:col-end-14 xl:col-span-8">
      <div class="flex flex-col gap-2 md:gap-0 md:rounded-lg md:border md:border-outline/16">
        <ProfileBanner
          v-if="$window.width >= 905"
          class="hidden md:block"
          :src="company.banner_image"
        />
        <keep-alive>
          <component
            :is="currentTabComponent"
            :isUserOwner="isUserOwner"
            :company="company"
            :jobs="jobs"
            class="md:p-7 md:pt-4"
          />
        </keep-alive>
      </div>
    </main>
  </div>
</template>

<script>
import getPropertiesIfExistFromDataObjectMixin from '@/getPropertiesIfExistFromDataObject.mixin.js'
import { Head } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/Layout'
import Icon from '@/Components/Icon'
import Button from '@/Components/Button'
import ButtonIcon from '@/Components/ButtonIcon'
import Divider from '@/Components/Divider'
import ProfileBanner from '@/Components/ProfileBanner'
import ProfilePicture from '@/Components/ProfilePicture'
import CompanyProfileMainTab from '@/Components/CompanyProfileMainTab'
import CompanyProfileJobsTab from '@/Components/CompanyProfileJobsTab'
import ListItemWithDivider from '@/Components/ListItemWithDivider'

export default {
  name: 'CompanyProfile',
  layout: Layout,
  components: {
    Head,
    Icon,
    Button,
    ButtonIcon,
    Divider,
    ProfileBanner,
    ProfilePicture,
    CompanyProfileMainTab,
    CompanyProfileJobsTab,
    ListItemWithDivider,
  },
  mixins: [getPropertiesIfExistFromDataObjectMixin],
  props: {
    isUserOwner: {
      type: Boolean,
      required: false,
      default: false,
    },
    errors: {
      type: Object,
    },
    company: {
      type: Object,
      required: true,
    },
    jobs: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      currentTab: 'main',
    }
  },
  computed: {
    currentTabComponent() {
      return `CompanyProfile${this.currentTab.charAt(0).toUpperCase() +
        this.currentTab.slice(1)}Tab`
    },
    companySocialMedia() {
      return this.getPropertiesIfExistFromDataObject('company', {
        whatsapp_url: { icon: 'whatsapp' },
        fb_url: { icon: 'round-facebook' },
        linkedin_url: { icon: 'linkedin' },
        website_url: { icon: 'web' },
      })
    },
  },
  methods: {
    async shareProfile() {
      const shareData = {
          url: window.location,
          title: `Perfil de ${this.company.name} | Bolsa de Trabajo`,
        },
        sweetAlertConfig = {
          toast: true,
          timer: 3000,
          position: 'bottom',
          showConfirmButton: false,
          timerProgressBar: true,
          customClass: {
            popup: '!surface3 !rounded-2xl !py-2',
            icon: '!bg-transparent',
            title:
              '!text-on-surface-variant !font-sans !font-medium !text-base !tracking-wide !text-center',
          },
        }

      this.$swal.fire({ ...sweetAlertConfig, title: 'Copiado al portapapeles' })
    },
  },
  mounted() {
    this.$nextTick(function() {
      window.scrollTo(0, 0)
    })
  },
}
</script>
